import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';
import { useDispatch} from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { updatePaymentDetails, updateBuyerPaymentDetails } from "redux/actions/payment";
import NumberInput from 'web/components/form-elements/NumberInput';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './popup.scss';

export default ({ isOpen, toggle, accountResponse, popupType, setTouched, validateForm, callBackFetchApi, content, link, onClickHander }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem("token");
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const [modalAlertType, setModalAlertType] = useState();
  const toggleModal = () => setModal(!modal);
  let title = '';

  const redirectLink = (link) => {
    toggle(!isOpen)
  }
  const callBackFun = () => {
    toggle(!isOpen)
  }
  const getRegisterInitialValues = () => {
    return {
      expMonth: accountResponse?.expMonth || '',
      expYear: accountResponse?.expYear || ''
    }
  }
  const VALIDATION_SCHEMA = Yup.object().shape({
    expMonth: Yup.string().trim().required('Please enter expire month.'),
    expYear: Yup.string().trim().required('Please enter expire year.')
  });

  const submitHandler = async (props) => {
    let response;
    if (props.values.expMonth !== '' && props.values.expYear !== '') {
      if (popupType === "Buyer") {
        let data = {
          paymentDetailsId: accountResponse && accountResponse.id,
          name: accountResponse && accountResponse.name,
          expMonth: props.values.expMonth,
          expYear: props.values.expYear,
        };
        response = await dispatch(updateBuyerPaymentDetails(data, token));
        if (response.status === "SUCCESS") {
          setModalAlertType('success')
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        } else {
          if (response.statusCode === 401) {
            history.push('/sign-in');
            window.location.reload(false);
          } else {
            setModalContent(response.message);
            setModalLink('');
            toggleModal();
          }
        }
      }
      else {
        let data = {
          name: accountResponse && accountResponse.name,
          expMonth: props.values.expMonth,
          expYear: props.values.expYear,
        };
        response = await dispatch(updatePaymentDetails(data, token));
        if (response.status === "SUCCESS") {
          onClickHander('payment')
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        } else {
          if (response.statusCode === 401) {
            history.push('/sign-in');
            window.location.reload(false);
          } else {
            setModalContent(response.message);
            setModalLink('');
            toggleModal();
          }
        }
      }
    }
  };

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='card-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              onClickHander()
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>Card Details</h3>
          </div>
          <ModalBody>
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>

            <div className='modal-content'>
              <Formik
                validateOnMount
                enableReinitialize={true}
                initialValues={getRegisterInitialValues()}
                validationSchema={VALIDATION_SCHEMA}
                onSubmit={(values) => { }}
              >
                {(props) => {
                  const { values, setFieldValue, isValid, dirty } = props;
                  return (
                    <Form className="form">
                      <div><div class="app-input-text"></div></div>
                      <div><p>Expire Month<span class="star">*</span></p>
                        <div>
                          {/* <NumberInput name='expMonth' format="##/##" placeholder="MM/YY" mask={['M', 'M', 'Y', 'Y']} /> */}
                          <NumberInput
                            name='expMonth'
                            placeholder='Enter expire month'
                            maxLength='2'
                          />
                        </div>
                      </div>
                      <div><p>Expire Year<span class="star">*</span></p>
                        <div>
                          <NumberInput
                            name='expYear'
                            placeholder='Enter expire year'
                            maxLength='4'
                          />
                        </div>
                      </div>
                      <Button
                        type='app-green-button'
                        disabled={!(isValid && dirty)}
                        handleClick={() => {
                          submitHandler(props);
                        }}
                      >
                        Submit
                      </Button>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
          </ModalFooter>
        </div>
      </Modal>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
        alertType={modalAlertType}
        callBackAlert={() => {
          if(modalAlertType === 'success'){
            onClickHander('payment')
            setModalAlertType()
          }
        }}
      />
    </div>
  );
};